import { mountStoreDevtool } from "simple-zustand-devtools";
import { setAnalyticsIdentity } from "utils/analytics";
import { config } from "utils/config";
import { setPostHogCompany } from "utils/posthog";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface CompanyState {
	id: number | null;
	setCompany: (id: number | null) => void;
	reset: () => void;
}

const initialState = {
	id: null,
};

const useCompanyStore = create<CompanyState>()(
	persist(
		(set) => ({
			...initialState,
			setCompany: (id: number | null) => {
				// 🪤 Some callers hand this a whole company object rather than an
				// id (see pages/setup/*), which is a pre-existing type lie this
				// change does not fix. Read the id defensively so the analytics
				// property is a number or nothing — never "[object Object]".
				const companyId =
					typeof id === "number"
						? id
						: typeof (id as any)?.id === "number"
							? (id as any).id
							: null;
				setPostHogCompany(companyId);
				// `setPostHogCompany` sets a PostHog PERSON property, which is not
				// visible to a query over event properties — the activation funnel
				// filters on `properties.companyId`. This puts the same id on the
				// event itself, for every `trackActivation` call that follows.
				setAnalyticsIdentity({ companyId });
				set(() => ({ id }));
			},
			reset: () => {
				set(initialState);
			},
		}),
		{
			name: "company-storage",
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);

const setCompanyStore = (_: string) => {
	// useCompanyStore.persist.setOptions({
	//   name: `company-storage-${userUid}`,
	// })
};

if (config.isLocal && config.isDev) {
	mountStoreDevtool("Auth", useCompanyStore);
}

export { setCompanyStore, useCompanyStore };
